// A page for a bunch of shared functions

/**
 * Convert date strings from YYYY/MM/DD to 'MMM DD, YYYY'
 * @param timeString the time string that will be altered
 * @return {{String}} returns the formatted date string
 */
export const convertDateToLongDate = (timeString) => {
	let date = new Date(timeString);
	let month = date.toLocaleString('default', { month: 'long' });
	return month + ' ' + date.getDate() + ', ' + date.getFullYear();
};
